import { forwardRef } from 'react';

const PrivacyPolicy = forwardRef<HTMLElement>((props, ref) => {
  return (
    <section ref={ref} className="bg-[#F8F6F3] py-16 md:py-[160px] opacity-0 transition-all duration-[800ms]" id="privacy">
      <div className="max-w-[900px] mx-auto px-6 md:px-8">

        <h2
          className="font-serif leading-[1.1] tracking-[-0.01em] text-black mb-10 md:mb-[60px]"
          style={{ fontSize: 'clamp(28px, 6vw, 56px)', fontFamily: '"Playfair Display", Georgia, serif' }}
        >
          Privacy &amp; Confidentiality
        </h2>

        <div className="space-y-10 md:space-y-[48px]">
          {[
            {
              title: 'Our Commitment to Discretion',
              body: 'Anteroom Sovereign Advisory operates under the strictest standards of confidentiality. All client engagements, communications, and strategic counsel are protected by comprehensive non-disclosure agreements and institutional privacy protocols.',
            },
            {
              title: 'Data Protection',
              body: 'All client data is encrypted, stored on secure servers with restricted access, and retained only for the duration necessary to fulfill our advisory mandate. We do not share, sell, or disclose client information to third parties under any circumstances.',
            },
            {
              title: 'Sovereign Privilege',
              body: 'We recognize and respect the unique confidentiality requirements of sovereign entities. Our protocols are designed to meet the highest standards of diplomatic and governmental discretion, ensuring that sensitive strategic matters remain protected.',
            },
            {
              title: 'Contact for Privacy Inquiries',
              body: 'For questions regarding our privacy practices or to exercise your data rights, please contact our Privacy Officer at privacy@anteroom.advisory',
            },
          ].map((item, i) => (
            <div key={i}>
              <h3
                className="font-serif tracking-[-0.005em] text-black mb-4 md:mb-[20px]"
                style={{ fontSize: 'clamp(18px, 3vw, 24px)', fontFamily: '"Playfair Display", Georgia, serif' }}
              >
                {item.title}
              </h3>
              <p className="text-[#6B6B6B] text-[14px] md:text-[16px] leading-[1.8] tracking-[0.02em] font-sans">
                {item.body}
              </p>
            </div>
          ))}

          {/* Information Collection */}
          <div>
            <h3
              className="font-serif tracking-[-0.005em] text-black mb-4 md:mb-[20px]"
              style={{ fontSize: 'clamp(18px, 3vw, 24px)', fontFamily: '"Playfair Display", Georgia, serif' }}
            >
              Information Collection
            </h3>
            <p className="text-[#6B6B6B] text-[14px] md:text-[16px] leading-[1.8] tracking-[0.02em] font-sans mb-4">
              We collect only essential information required to provide strategic advisory services:
            </p>
            <ul className="list-none space-y-3 ml-4 md:ml-[24px]">
              {[
                'Contact details and institutional affiliation',
                'Strategic context and advisory requirements',
                'Communication preferences and engagement parameters',
              ].map((item, i) => (
                <li key={i} className="text-[#6B6B6B] text-[14px] md:text-[16px] leading-[1.8] tracking-[0.02em] font-sans flex gap-3">
                  <span className="text-[#C9A96E] shrink-0">—</span>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          <div className="pt-6 md:pt-[32px] border-t border-[#3A3D42]/20">
            <p className="text-[#6B6B6B] text-[13px] md:text-[14px] leading-[1.8] tracking-[0.02em] font-sans">
              Last updated: January 2026
            </p>
          </div>
        </div>
      </div>
    </section>
  );
});

PrivacyPolicy.displayName = 'PrivacyPolicy';

export default PrivacyPolicy;